import { render, staticRenderFns } from "./MpIngredientUsage.vue?vue&type=template&id=ceb33b54&lang=pug&"
import script from "./MpIngredientUsage.vue?vue&type=script&lang=js&"
export * from "./MpIngredientUsage.vue?vue&type=script&lang=js&"
import style0 from "./MpIngredientUsage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
